import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { INVESTMENTS_GET_PNL } from '@/common/paths';

const useGetPNLQuery = () => {
  const { isLoading, data, isSuccess } = useQuery([], () => api.get(INVESTMENTS_GET_PNL));

  const formattedData = useMemo(() => {
    if (!data?.data) {
      return null;
    }
    const payload = data.data;
    return {
      lifetime: {
        amount: payload?.lifetime_pnl?.amount || 0,
        percentage: payload?.lifetime_pnl?.percentage || 0,
      },
      month: {
        amount: payload?.thirty_day_pnl?.amount || 0,
        percentage: payload?.thirty_day_pnl?.percentage || 0,
      },
      year: {
        amount: payload?.year_to_date_pnl?.amount || 0,
        percentage: payload?.year_to_date_pnl?.percentage || 0,
      },
    };
  }, [data]);
  return {
    data: formattedData,
    isSuccess,
    isLoading: isLoading || !isSuccess,
  };
};
export default useGetPNLQuery;
